import { Helmet } from 'react-helmet';
import { IResetPasswordWithTempPasswordProps } from '../../types/propTypes';
import { confirmSignInWithNewPassword } from '../../services/login/login-service';
import { IResetPasswordWithTempPasswordField } from '../../models/login';
import { Formik, Field } from 'formik';
import { Form, Button } from 'react-bootstrap';
import { ReactstrapFormikPasswordInput } from '../../components/reactstrap-formik';
import { ResetPasswordWithTempPasswordValidationSchema } from '../../validation/login/login-validation';
import { Common } from '../../utils/constants';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { companyNameReplace } from '../../utils';
import images from '../../assets/images';
import { emailNotification } from '../../services/login/loginApi-service';

const ResetPasswordWithTempPasswordForm = ({ email, onChangeStage }: IResetPasswordWithTempPasswordProps) => {
  const { t } = useTranslation();
  const initialState: IResetPasswordWithTempPasswordField = {
    password: '',
    confirmPassword: '',
  };

  const handleSubmit = async (value: IResetPasswordWithTempPasswordField) => {
    return confirmSignInWithNewPassword(value.password)
      .then((res) => {
        toast.success(t('forgot.toast.success'));
        emailNotification(String(email));
        const nextStage =
          res.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE'
            ? Common.AuthStage.SIGNIN_OTP
            : Common.AuthStage.SIGNIN;
        onChangeStage(nextStage);
      })
      .catch((err) => {
        if (err && err.name === Common.Authentication.InvalidParameterException) {
          toast.error(t('forgot.toast.invalidCode'));
        } else {
          toast.error(t('forgot.toast.error'));
        }
      })
      .finally();
  };

  return (
    <>
      <Helmet>
        <title>{companyNameReplace(t('forgot.resetTitle'))}</title>
      </Helmet>

      <div className="login-form">
        <div className="title-outer mb-4">
          <h1 className="title">
            <img src={images.logoIconPNG} alt={companyNameReplace(t<string>('login.label.logo'))} />
            {t('forgot.resetTempPasswordHeader')}
          </h1>
        </div>

        <Formik
          initialValues={initialState}
          onSubmit={handleSubmit}
          validationSchema={ResetPasswordWithTempPasswordValidationSchema(t)}
        >
          {(props) => {
            const { handleSubmit, values, isValid } = props;

            let buttonText = t('forgot.button.save');
            let isDisabled = true;

            if (!(values.password && values.confirmPassword)) {
              buttonText = t('forgot.button.enterNewPassword');
              isDisabled = true;
            } else {
              buttonText = t('forgot.button.resetPassword');
              isDisabled = !isValid;
            }

            return (
              <form className="form-secondary" onSubmit={handleSubmit} autoComplete="off" noValidate>
                <input type="text" name="username" autoComplete="username" className="hidden-input" />
                <Field
                  type="password"
                  name="password"
                  id="Password"
                  label={t('forgot.form.password')}
                  component={ReactstrapFormikPasswordInput}
                  autoComplete="new-password"
                />
                <Field
                  type="password"
                  name="confirmPassword"
                  id="ConfirmPassword"
                  label={t('forgot.form.confirmPassword')}
                  autoComplete="new-password"
                  component={ReactstrapFormikPasswordInput}
                />
                <Form.Group className="form-group">
                  <Button
                    type="submit"
                    className={`btn btn-${isDisabled ? 'secondary' : 'primary'} w-100`}
                    disabled={isDisabled}
                  >
                    {buttonText}
                  </Button>
                </Form.Group>
              </form>
            );
          }}
        </Formik>
      </div>
    </>
  );
};

export default ResetPasswordWithTempPasswordForm;
